import { Button, FlexBox, Text } from '@trmediaab/zebra';
import { Chevron } from '@trmediaab/zebra-icons';
import PropTypes from 'prop-types';
import { useState } from 'react';

import { EMPTY_VALUE_CHARACTER } from '~/utils/numbers';

function stripNewline(str) {
  if (!str) {
    return str;
  }
  const leadingOrTrailingNewline = /^\n|\n$/g;
  return str.replaceAll(leadingOrTrailingNewline, '');
}

function stripInitial(str, replace) {
  if (!str || !replace) {
    return str;
  }
  return str.replace(replace, '');
}

const Proposition = ({ proposition, raceName, raceNumber, trackName }) => {
  const [open, setOpen] = useState(false);

  if (proposition == null) {
    return null;
  }

  return (
    <Button
      fontSize="2"
      fontWeight="medium"
      textAlign="left"
      alignItems="start"
      color="greys.4"
      onClick={() => setOpen(!open)}
      lineHeight="base"
    >
      <Chevron
        direction={open ? 'down' : 'right'}
        size="22px"
        mt="2px"
        color="text.tertiary"
        flexShrink="0"
        mr="2"
      />
      <FlexBox flexDirection="column" gap="2">
        <Text
          color="greys.4"
          lineHeight="24px"
          whiteSpace={open ? 'pre-line' : 'pre'}
          sx={
            !open
              ? {
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }
              : undefined
          }
        >
          {`${trackName} lopp ${raceNumber}${raceName ? `, ${raceName}` : ''}`}
        </Text>
        {open && (
          <Text whiteSpace="pre-line">
            {stripNewline(stripInitial(proposition, raceName)) ||
              EMPTY_VALUE_CHARACTER}
          </Text>
        )}
      </FlexBox>
    </Button>
  );
};

Proposition.propTypes = {
  proposition: PropTypes.string,
  raceName: PropTypes.string,
  trackName: PropTypes.string,
  raceNumber: PropTypes.number,
};

export default Proposition;
